import React, { useContext, useState } from 'react';
import { TextField, Select, MenuItem, InputLabel, FormControl, FormGroup, Typography, Box, Divider } from '@mui/material';
import '../../pages/createStudy/createStudy.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import UserContext from '../../Context/User/userContext.jsx';

const StudyFormForUser = ({ setShowSpinner, data }) => {
  const study = data && data[0]; // Assuming data is an array and study is the first element
  const [pi, setPi] = useState(study ? study.pi : "");  // Initialize `pi` with the study data if available

  const reset = () => {
    setPi(''); // Reset the PI field when needed
  };

  // Bearer Token
  const token = localStorage.getItem('token');
  const tokenValue = token ? token.slice(1, token.length - 1) : "";

  // User Object
  const { user } = useContext(UserContext);
  const _id = user && (typeof user === 'string' ? JSON.parse(user)._id : user._id);

  const handleSubmit = () => {
    setShowSpinner(true);
    const myStudy = {
      studyId: study._id,
      pi,
      addedBy: _id,
    };
    const url = 'https://research-mate-b35a10757d5a.herokuapp.com/api/myStudy/';
    axios.post(url, myStudy, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${tokenValue}`
      }
    })
      .then(res => {
        console.log(res.data);
        Swal.fire({
          icon: "success",
          title: "Added...",
          text: res.data.message,
          customClass: {
            container: 'swal2-container-custom'
          }
        });
        reset();
      })
      .catch(error => {
        console.log("error--->", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response?.data?.message || error,
          customClass: {
            container: 'swal2-container-custom'
          }
        });
      });
    setShowSpinner(false);
  };

  return (
    <Box sx={{ p: 3, color: '#169a8f', fontWeight: 'bold' }}>
      <Box>
        <Typography variant="h6">Study Criteria</Typography>
        <FormGroup row sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
          <FormControl sx={{ mr: 3 }}>
            <InputLabel id="status-label">Status</InputLabel>
            <Select
              labelId="status-label"
              id="status"
              value={'active'}
              label="Status"
            >
              <MenuItem value="active" selected>Active</MenuItem>
            </Select>
          </FormControl>

          <FormControl sx={{ mr: 3 }}>
            <TextField
              id="phase"
              value={study?.phase || ''}  // Ensure value is always controlled
              label="Phase"
              onChange={(e) => {}}
            />
          </FormControl>

          <TextField
            id="activation-date"
            label="Activation Date"
            type="date"
            value={study ? new Date(study.createdAt).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10)}
            InputLabelProps={{ shrink: true }}
            sx={{ mr: 3 }}
          />
          
          <TextField
            id="submission-date"
            label="Submission Date"
            type="date"
            value={study ? new Date(study.submissionDate).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10)}
            InputLabelProps={{ shrink: true }}
            sx={{ mr: 3 }}
          />
          
          <TextField
            id="PI"
            value={pi}
            required
            onChange={e => setPi(e.target.value)}
            label="PI"
          />

          <div className='ml-auto'>
            <div className='study-form-btn'>
              <button className="button close" data-text="Awesome" onClick={handleSubmit}>
                <span className="actual-text">&nbsp;AcceptStudy&nbsp;</span>
                <span aria-hidden="true" className="hover-text">&nbsp;AcceptStudy&nbsp;</span>
              </button>
            </div>
          </div>
        </FormGroup>

        <TextField
          id="input-title"
          label={'Title'}
          value={study?.title || ''}
          fullWidth sx={{ mt: 2 }}
        />

        <TextField
          id="therapeutic-areas"
          value={study?.therapeuticAreas || ''}
          label="Therapeutic Areas"
          fullWidth sx={{ mt: 2 }}
        />

        <TextField
          id="indication"
          value={study?.indication || ''}
          label="Indication"
          fullWidth sx={{ mt: 2 }}
        />
      </Box>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">Study Sponsors</Typography>
        <FormGroup row sx={{ mt: 2 }}>
          <TextField
            id="name-sponsors"
            value={study?.sponsorName || ''}
            label="Name Sponsors"
            sx={{ mr: 3 }}
          />
          <TextField
            id="cro"
            value={study?.CRO || ''}
            label="CRO"
          />
        </FormGroup>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Divider />
        <Typography variant="h6" sx={{ mt: 2 }}>Criteria</Typography>
        <Box sx={{ mt: 2 }}>
          <TextField
            id="inclusion-criteria"
            label="Inclusion Criteria"
            multiline
            rows={6}
            fullWidth
            value={study?.inclusionCriteria || ''}
          />
        </Box>

        <Box sx={{ mt: 2 }}>
          <TextField
            id="exclusion-criteria"
            label="Exclusion Criteria"
            multiline
            rows={6}
            fullWidth
            value={study?.exclusionCriteria || ''}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default StudyFormForUser;
